import * as React from 'react';
import { injectTSDI } from '../../core/tsdi';
import { I18nStore } from '../../core/i18n-store';
import { FacebookPolicy, GooglePolicy } from './components';
import { CookieInfo } from './index';

export const getNecessaryInfo = (): CookieInfo[] => {
    const { translate } = injectTSDI(I18nStore);
    return [
        {
            name: translate('onlinepages.cookies.necessary'),
            description: translate('onlinepages.cookies.necessary.description'),
            providers: translate('onlinepages.cookies.internal')
        }
    ];
};
export const getMarketingInfo = (): CookieInfo[] => {
    const { translate } = injectTSDI(I18nStore);
    return [
        {
            name: '_fbp',
            description: translate('onlinepages.cookies.facebook'),
            providers: <FacebookPolicy>Facebook</FacebookPolicy>,
            expiration: translate('commons.months.some', 3)
        },
        {
            name: '_ga',
            description: translate('onlinepages.cookies.ga'),
            providers: <GooglePolicy>Google Tag Manager Google</GooglePolicy>,
            expiration: translate('commons.years.some', 2)
        },
        {
            name: '_gid',
            description: translate('onlinepages.cookies.gid'),
            providers: <GooglePolicy>Google</GooglePolicy>,
            expiration: translate('commons.days.one', 1)
        },
        {
            name: '_gat_gtag_[x]',
            description: translate('onlinepages.cookies.gat.gtag'),
            providers: <GooglePolicy>Google Tag Manager Google</GooglePolicy>,
            expiration: translate('commons.days.one', 1)
        }
    ];
};
